import { ROUTE_TEXT_MATERIALS_CATEGORIES_ADD, ROUTE_TEXT_MATERIALS_THEMES_ADD } from '@@partner:config/routes'
import { useFetchAllTextMaterialThemes } from '@@partner:graphql/query/textMaterial/themes/allTextMaterialThemes.gql'
import { convertToInt } from '@@partner:helpers/util'
import { CommonSort, NestedFilter } from '@@partner:types:graphql'
import TextMaterialsTopMenu from '@components/textMaterials/TextMaterialsTopMenu'
import TextMaterialThemesTable from '@components/textMaterials/theme/grid/TextMaterialThemesTable'
import React, { useCallback, useState } from 'react'
import { AddOutline } from 'react-ionicons'
import { generatePath, NavLink, useParams } from 'react-router-dom'
import { Nav, Navbar, Panel } from 'rsuite'


export default function TextMaterialThemesPage () {
  const { brandSlug } = useParams<any>()

  const [ page, setPage ] = useState(1)
  const [ filter, setFilter ] = useState<NestedFilter>({
    fields: [ 'id' ],
    op: 'unwrap'
  })
  const [ sort, setSort ] = useState<CommonSort>({
    fieldName: 'id',
    direction: 0
  })
  
  const { data, loading, error } = useFetchAllTextMaterialThemes({
    filter,
    pager: {
      page,
      limit: 10
    },
    sort
  })

  const handlePageSelect = useCallback((selectedPage: string | number) => {
    setPage(convertToInt(selectedPage))
  }, [])

  const handleSortColumn = useCallback((sortColumn, sortType) => {
    setSort({
      fieldName: sortColumn,
      direction: sortType === 'desc' ? 0 : 1
    })
  }, [])

  const allThemes = data?.allTextMaterialThemes.edges ?? []
  const pageInfo = data?.allTextMaterialThemes.pageInfo

  const showPagination = pageInfo?.lastPage !== 1


  return (
    <div>
      <h1 className="u-heading">Темы контента</h1>
      <TextMaterialsTopMenu />
      <Navbar appearance='subtle'>
        <Nav>
          <Nav.Item
            icon={<AddOutline />}
            as={NavLink}
            to={generatePath(ROUTE_TEXT_MATERIALS_THEMES_ADD, {
              brandSlug
            })}
          >
             Добавить тему
          </Nav.Item>
        </Nav>
      </Navbar>

      <Panel shaded>
        { allThemes && (
          <TextMaterialThemesTable 
            brandSlug={brandSlug}
            textMaterialThemes={allThemes}
            loading={loading}
          />
        )}
      </Panel>
    </div>
  )
}